// extracted by mini-css-extract-plugin
export default {"clinicCardContentIcon":"ClinicCardList-module__clinicCardContentIcon--PeKRE"};